import {
    useCallback,
} from 'react'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'
import StatusHandler from 'app/shared-components/StatusHandler'
import useFilter from 'app/hooks/useFilter'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'
import {
    useGetRequestSpreadSheetAdapter,
} from 'app/shared-components/SkyNetSpreadSheet'
import {
    SkyNetPaginationContext, useSkyNetPagination,
} from 'app/shared-components/SkyNetPagination'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Opportunity/Opportunity.requests'
import OpportunitiesSpreadSheet from '../OpportunitiesSpreadSheet'
import {
    OpportunityBulkEditType, OpportunityType,
} from '../opportunities.types'
import dataAdapter from './OpportunitiesBulkEdit.utils'

const OpportunitiesBulkEdit = ({
    onClose,
}: Readonly<{
    onClose: () => void
}>) => {
    const filterOptions = useFilter<OpportunityType[]>()
    const paginationOptions = useSkyNetPagination(25)

    const {
        isError,
        loaded,
        error,
        refetch,
    } = useGetRequestSpreadSheetAdapter<OpportunityBulkEditType, OpportunityType>({
        filterOptions,
        paginationOptions,
        dataAdapter,
        config: requests.spreadsheet,
        requestKey: RequestKeys.getOpportunities,
        enabled: false,
    })

    const {
        mutateAsync: opportunitiesEdit,
    } = useSimpleApiRequest({
        name: 'OpportunitiesBulkEdit',
        requestParams: requests.bulkEdit(),
        title: 'Opportunities were updated',
        onSuccess: refetch,
    })

    const onSave = useCallback(async (
        opportunities: OpportunityType[],
        options?: AsyncMutationOptions,
    ) => {
        await opportunitiesEdit(opportunities, {
            ...options,
            onSuccess: options?.onSuccess || onClose,
        })
    }, [
        opportunitiesEdit,
        onClose,
    ])

    return (
        <StatusHandler
            isError={isError}
            isFetching={!loaded}
            error={error}
            isSuccess={loaded}
        >
            <SkyNetPaginationContext.Provider value={paginationOptions}>
                <OpportunitiesSpreadSheet
                    onSave={onSave}
                    onCancel={onClose}
                    filterOptions={filterOptions}
                />
            </SkyNetPaginationContext.Provider>
        </StatusHandler>
    )
}

export default OpportunitiesBulkEdit
